import { HStack } from '@talos/kyoko';
import { PriceGridMultiSelectFilter } from './PriceGridMultiSelectFilter';
import type { usePriceGridFilterControls } from './usePriceGridFilterControls';

const MARKET_FILTER_TOOLTIP = 'View symbols that are supported on the selected Market(s)';
const CURRENCY_FILTER_TOOLTIP = 'View symbols where the Base or Quote currency matches the selected Currency.';
const BASE_PAIR_FILTER_TOOLTIP =
  'View symbols where the Base and Quote currency matches the selected Pair. For example, filtering on BTC-USD will return BTC-USD Spot, Perps and Futures.';

interface PriceGridSymbolFiltersProps {
  controls: ReturnType<typeof usePriceGridFilterControls>;
  showMarkets?: boolean;
}

export function PriceGridSymbolFilters({ controls, showMarkets = true }: PriceGridSymbolFiltersProps) {
  return (
    <HStack gap="spacing8" alignItems="center" alignSelf="center">
      {showMarkets && (
        <PriceGridMultiSelectFilter
          width="120px"
          tooltip={MARKET_FILTER_TOOLTIP}
          defaultLabel="All Markets"
          property={controls.markets.property}
          selections={controls.markets.selections}
          onSelectionsChange={controls.markets.onSelectionsChange}
          buttonTestID="price-grid-markets-filter"
        />
      )}
      <HStack gap="spacing8" data-testid="price-grid-symbol-filter-tour-anchor">
        <PriceGridMultiSelectFilter
          width="120px"
          tooltip={CURRENCY_FILTER_TOOLTIP}
          defaultLabel="All Ccy"
          property={controls.currencies.property}
          selections={controls.currencies.selections}
          onSelectionsChange={controls.currencies.onSelectionsChange}
          buttonTestID="price-grid-currencies-filter"
        />
        <PriceGridMultiSelectFilter
          width="120px"
          tooltip={BASE_PAIR_FILTER_TOOLTIP}
          defaultLabel="All Base Pairs"
          property={controls.basePairs.property}
          selections={controls.basePairs.selections}
          onSelectionsChange={controls.basePairs.onSelectionsChange}
          buttonTestID="price-grid-base-pairs-filter"
        />
      </HStack>
    </HStack>
  );
}
